import { AMUSEMENT_TICKET_DETAIL_TABS } from 'modules/Amusement/AmusementTicketDetailPage/constants';
import { PEAK_SEASON_CONFIG_TYPE } from 'modules/Configuration/PeakSeasonConfigPage/constants';
import {
  HOTEL_DETAIL_TABS,
  HOTEL_ROOM_DETAIL_TABS,
} from 'modules/Hotel/HotelDetailPage/constants';
import { REGION, MODULE_TYPE } from 'utils/constants';

const publicPaths = {
  loginPage: (redirectedFrom?: string) =>
    `/auth/login${redirectedFrom ? `?${redirectedFrom}` : ''}`,
};

const privatePaths = {
  portalPage: () => '/',
  dashboardPage: () => '/dashboard',

  /** Configuration */
  peakSeasonConfigPage: (
    moduleType: MODULE_TYPE,
    configType: PEAK_SEASON_CONFIG_TYPE
  ) => `/${moduleType}/config/${configType}`,

  /** Hotel */
  hotelListPage: () => `/${MODULE_TYPE.HOTEL}/list`,
  hotelDetailPage: (hotelId: string, section: HOTEL_DETAIL_TABS) =>
    `/${MODULE_TYPE.HOTEL}/detail/${hotelId}/${section}/`,
  hotelRoomDetailPage: (
    hotelId: string,
    roomId: string,
    section: HOTEL_ROOM_DETAIL_TABS
  ) =>
    `/${MODULE_TYPE.HOTEL}/detail/${hotelId}/${HOTEL_DETAIL_TABS.ROOM_DETAILS}/${roomId}/${section}/`,
  hotelBookingReportPage: () => `/${MODULE_TYPE.HOTEL}/booking/report`,

  /** Tour */
  tourRouteManagementPage: (region: REGION) =>
    `/${MODULE_TYPE.TOUR}/route/${region}/list`,
  tourListPage: (region: REGION) => `/${MODULE_TYPE.TOUR}/${region}/list`,
  tourDetailPage: (tourId: string) => `/${MODULE_TYPE.TOUR}/${tourId}`,
  tourBookingListPage: (queryParams?: string) =>
    `/${MODULE_TYPE.TOUR}/booking/list${queryParams ? `?${queryParams}` : ''}`,

  /** Amusement */
  amusementListPage: () => `/${MODULE_TYPE.AMUSEMENT_TICKETS}/list`,
  amusementTicketDetailPage: (
    amusementTicketId: string,
    section: AMUSEMENT_TICKET_DETAIL_TABS
  ) => `/${MODULE_TYPE.AMUSEMENT_TICKETS}/${amusementTicketId}/${section}`,
};

const pathsMap = {
  ...publicPaths,
  ...privatePaths,
};

export type PathsMap = typeof pathsMap;

export const getPath = <TRoute extends keyof PathsMap>(
  route: TRoute,
  ...params: Parameters<PathsMap[TRoute]>
) => {
  const pathCb: (...args: any[]) => string = pathsMap[route];
  return pathCb(...params);
};
